<template>
  <v-app>
    <TheDrawer :drawer="drawer" />

    <v-app-bar dark app v-if="isLoggedIn">
      <AppLogo />
      <v-app-bar-nav-icon @click.stop="toggleDrawer" v-if="isLoggedIn">
        <v-icon>{{ drawerIcon }}</v-icon>
      </v-app-bar-nav-icon>
      <v-spacer></v-spacer>

      <v-btn small class="mr-2" color="#006CEA" v-if="isLoggedIn" @click="uploadDialog = true">
        <v-icon small class="mr-2">mdi-tray-arrow-up</v-icon>
        업로드
      </v-btn>

      <router-link to="/vod-manual" target="_blank">
        <v-btn class="mr-2" small color="rgba(255, 255, 255, 0.15)" v-if="isLoggedIn">
          <v-icon small class="mr-2">mdi-file-document-outline</v-icon>
          매뉴얼
        </v-btn>
      </router-link>

      <!-- <v-btn class="mr-2" small color="rgba(255, 255, 255, 0.15)" v-if="isLoggedIn">
        {{ email }}
      </v-btn> -->

      <AccountInfo v-if="isLoggedIn"/>


      <!-- <Logout v-if="isLoggedIn" /> -->

    </v-app-bar>

    <Upload :dialog.sync="uploadDialog" :multiple="true" @filesUploaded="processUpload($event)" />

    <!-- <MyModal v-if="isModalOpen" @close="closeModal" :files="uploadedFiles" /> -->

    <v-main style="height: 100%;">
      <v-container fluid style="padding: 0px;height: 100%;">
        <router-view />
        <snackbar :message="snackbarMessage" :visible="snackbarVisible" :error="snackbarError" />
      </v-container>
    </v-main>

  </v-app>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import AppLogo from '@/components/app/AppLogo.vue';
import Logout from '@/components/user/LogoutForm.vue';
import TheDrawer from './TheDrawer.vue';
import Upload from '@/components/upload/UploadDialog.vue';
// import MyModal from '@/components/upload/t2.vue';
//import Snackbar from '@/components/ui/snackbar/Snackbar.vue';
import Snackbar from '@/components/ui/snackbar/UploadSnackbar.vue';
import AccountInfo from '@/components/user/AccountInfo.vue';

export default {
  name: 'TheMain',
  components: {
    AppLogo,
    Logout,
    TheDrawer,
    Upload,
    // MyModal,
    Snackbar,
    AccountInfo
  },
  data() {
    return {
      drawer: true,
      miniState: false,
      selectedItem: null,
      mini: false,
      subMenuDrawer: false,
      groupListDrawer: false,
      uploadDialog: false,
      snackbarVisible: false,
      snackbarMessage: '',
      snackbarError: false
    };
  },
  mounted() {
    if (this.isLoggedIn) {
      this.$store.dispatch('user/adminCheck');
    }
  },
  computed: {
    //...mapState('naviList', ['items']),
    ...mapGetters('test', ['isModalOpen']),
    // ...mapGetters('user', ['email']),
    ...mapGetters('upload', ['lastCompletedFileName']),
    isLoggedIn() {
      return this.$store.getters['user/isLoggedIn'];
    },
    drawerIcon() {
      return this.drawer ? 'mdi-chevron-left' : 'mdi-menu';
    },
  },
  methods: {
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    ...mapActions('test', [
      'toggleModal'
    ])
  },
  watch: {
    lastCompletedFileName(newName, oldName) {
      if (newName !== oldName && newName) {
        this.snackbarVisible = true;
        this.snackbarMessage = `${newName} 파일 업로드 성공`;
        setTimeout(() => {
          this.snackbarVisible = false;
        }, 10000);
      }
    }
  },
  // mounted() {
  //   if (this.isLoggedIn) {
  //     this.$store.dispatch('naviList/list');
  //   }
  // },
  // watch: {
  //   isLoggedIn(newVal) {
  //     if (newVal) {
  //       this.$store.dispatch('naviList/list');
  //     }
  //   }
  // }
};
</script>

<style scoped>
header {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  z-index: 99999 !important;
}

.group_list_drawer {
  margin-left: 60px;
}

.sub_menu_drawer {
  margin-left: 60px;
}


.navigation_drawer {
  margin-top: 64px;
}

.mini-items .v-list-item-icon {
  min-width: 56px;
}

.v-list-item {
  align-items: center !important;
}

.mini-items .v-list-item {
  justify-content: center;
}

.flex-container {
  display: flex;
  width: 100%;
}

.mini-items {
  width: 50px;
  transition: width 0.3s ease;
}

.selected-item {
  background-color: #e0e0e0;
}
</style>
